"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyWithRetry = void 0;
var react_1 = __importDefault(require("react"));
var lazyWithRetry = function (importer) {
    var retryImport = function () {
        return new Promise(function (resolve, reject) {
            // check if the window has already been refreshed
            var importerIdentifier = importer.toString();
            var key = "retry-".concat(importerIdentifier);
            var hasRefreshed = window.sessionStorage.getItem(key) === 'true';
            // try to import the component
            importer()
                .then(function (component) {
                window.sessionStorage.removeItem(key);
                resolve(component);
            })
                .catch(function (error) {
                if (!hasRefreshed) {
                    window.sessionStorage.setItem(key, 'true');
                    // refresh the page to load the new chunks
                    return window.location.reload();
                }
                reject(error);
            });
        });
    };
    return react_1.default.lazy(retryImport);
};
exports.lazyWithRetry = lazyWithRetry;
//# sourceMappingURL=lazy_with_retry.js.map